<template>
  <cos-modal
    v-model:visible="visible"
    :title="editForm.id ? '编辑' : '新增'"
    width="600px"
    @ok="handleSubmit"
    :confirmLoading="loading"
  >
    <a-form :model="editForm" ref="formRef" v-if="visible" autocomplete="off">
      <a-form-item name="arkCode" label="客户名称/代码" :rules="[{ required: true, message: '请输入' }]">
        <CusSelect appId="cos_fbu" v-model:value="editForm.arkCode" placeholder="请选择" @selectData="selectData" />
      </a-form-item>
      <a-form-item name="score" label="评分" :rules="[{ required: true, message: '请输入' }]">
        <a-input v-model:value="editForm.score" :maxlength="10" :precision="0" placeholder="请输入" v-trim />
      </a-form-item>
    </a-form>
  </cos-modal>
</template>
<script lang="ts">
import { ref } from 'vue'
import { addBiScore, updateBiScore } from '@/api/gucangSales/businessRuleSetting'
import type { FormInstance } from 'ant-design-vue'
import { AddBiScoreParams } from '@/typings/api/gucangSale'
import CusSelect from '@/components/CustomerCodeSelect/index.vue'
import { DcMessage } from '@dc-platform/dc-components'

export default { name: 'editModal' }
</script>
<script setup lang="ts">
const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const formRef = ref<FormInstance>()
const editForm = ref<AddBiScoreParams>({})
const emit = defineEmits(['success'])
const toggle = (row?: AddBiScoreParams) => {
  visible.value = !visible.value
  if (row && row.id) {
    editForm.value = { ...row }
  } else {
    editForm.value = {}
  }
}
const selectData = (value: string) => {
  editForm.value.cosId = value
}
const handleSubmit = () => {
  formRef.value?.validate().then(async () => {
    loading.value = true
    const { arkCode, cosId, score, id } = editForm.value
    const p = {
      arkCode,
      cosId,
      score
    }
    try {
      if (editForm.value.id) {
        await updateBiScore({ ...p, id: editForm.value.id })
      } else {
        await addBiScore(p)
      }
      loading.value = false
      emit('success', editForm.value?.id ? 'edit' : 'add')
      DcMessage.success(editForm.value?.id ? '编辑成功' : '新增成功')
      toggle()
    } catch (error) {
      loading.value = false
    }
  })
}
defineExpose({
  toggle
})
</script>

<style lang="scss"></style>
